import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTopbarHiddenTopWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTopbarHiddenTopWide"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM6 9.5H18V8H6V9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTopbarHiddenTopWide;
